import { rgba } from 'polished';
import styled from 'styled-components';

const AspspSectionSeparator = styled.div`
  width: 90rem;
  height: 1px;
  background: ${({ theme }) => rgba(theme.colors.grey2, 0.3)};
  transform: translateX(-8%);
`;
export default AspspSectionSeparator;
